import React, { useState } from 'react';
import { useDeepCompareEffect } from '@oscar/utils';
import { useLocation, useParams } from 'react-router-dom';

export default function useQuery() {
  const location = useLocation();
  const params = useParams();
  const [queryState, setQueryState] = useState<{
    location: ReturnType<typeof useLocation>;
    params: ReturnType<typeof useParams>;
    query?: Record<string, string>;
  }>({ location, params });

  const query = React.useMemo(() => {
    const { search } = location;

    const result = new URLSearchParams(search);
    const queries: { [name: string]: string } = {};
    result.forEach((value, key) => {
      queries[key] = value;
    });
    return queries;
  }, [location]);

  useDeepCompareEffect(() => {
    setQueryState({
      location,
      params,
      query,
    });
  }, [query, location, params]);
  return [queryState];
}
